import { FaUsers, FaCompass } from "react-icons/fa";
import ContentWithCards from "../components/shared/ContentWithCards";

const SuggestedCommunities = () => {
  return (
    <ContentWithCards>
      <div className="main-section bg-white border">
        <div className="p-3">
          <div className="flex items-center justify-start mb-4 border-b py-3 pl-2 pr-2">
            <div className="flex items-center gap-3">
              <span className="relative inline-flex w-8 h-8 items-center justify-center">
                <FaCompass className="w-7 h-7 text-primary-600" />
                <FaUsers className="absolute -bottom-0.5 -right-0.5 w-4 h-4 text-primary-600 bg-white rounded-full" />
              </span>
              <h2 className="text-lg font-semibold text-gray-700">
                Suggested Skills Communities
              </h2>
            </div>
          </div>

          <div className="text-center py-12">
            <div className="text-6xl mb-6">🚀</div>
            <p className="text-xl text-gray-700 font-roboto-flex mb-2">
              Coming Soon
            </p>
            <p className="text-base text-gray-500 font-roboto-flex">
              We're working on personalized community recommendations for you!
            </p>
          </div>
        </div>
      </div>
    </ContentWithCards>
  );
};

export default SuggestedCommunities;

